function ExcelFile (fileData) {
  this.fileData = fileData
  return this
}
ExcelFile.prototype.ReadBook = function () {
  return new Promise((resolve, reject) => {
    import('xlsx').then(XLSX => {
      const workbook = XLSX.read(this.fileData, { type: 'array' })
      resolve(workbook.SheetNames)
    }).catch((err) => {
      reject(err)
    })
  })
}

ExcelFile.prototype.ReadSheet = function (sheetIndex = 0) {
  return new Promise((resolve, reject) => {
    import('xlsx').then(XLSX => {
      const workbook = XLSX.read(this.fileData, { type: 'array' })
      const sheet = workbook.Sheets[workbook.SheetNames[sheetIndex]]
      const result = XLSX.utils.sheet_to_json(sheet, {
        header: 1,
        blankrows: false,
        defval: undefined,
        raw: false
      })
      resolve(result)
    }).catch(err => {
      reject(err)
    })
  })
}

export default function ExcelReader (file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = (e) => {
      resolve(new ExcelFile(e.target.result))
    }
    reader.onerror = (e) => {
      reject(e)
    }
    reader.readAsArrayBuffer(file)
  })
}
